/**
 * Operation handler registry.
 *
 * Each operation type (e.g. 'inventory.changeLocation', 'photo.upload')
 * registers a handler at app boot. The runner looks up the handler by
 * `op.operation` and invokes it. Adding a new operation = registering a new
 * handler — the runner never changes.
 *
 * Handlers should be idempotent where possible since the runner may retry
 * after a partial-failure.
 */

import type { OperationHandler } from './types.js'

const handlers = new Map<string, OperationHandler<any>>()

export function registerOperation<P>(operation: string, handler: OperationHandler<P>) {
  if (handlers.has(operation)) {
    console.warn(`[offline-queue] handler for "${operation}" replaced`)
  }
  handlers.set(operation, handler as OperationHandler<any>)
}

export function getHandler(operation: string): OperationHandler<any> | undefined {
  return handlers.get(operation)
}

export function listRegisteredOperations(): string[] {
  return Array.from(handlers.keys())
}
